import Icon from '../components/Icon.vue'

Icon.register({"hospital-symbol":{"width":512,"height":512,"paths":[{"d":"M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512 512 397.4 512 256 397.4 0 256 0zM368 376C368 380.4 364.4 384 360 384H312C307.6 384 304 380.4 304 376V288H208V376C208 380.4 204.4 384 200 384H152C147.6 384 144 380.4 144 376V136C144 131.6 147.6 128 152 128H200C204.4 128 208 131.6 208 136V224H304V136C304 131.6 307.6 128 312 128H360C364.4 128 368 131.6 368 136V376z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hospital-symbol.js
// module id = SPhT
// module chunks = 0